var map = {
	"./3xlogo.svg": "27ae",
	"./404icon.svg": "6390",
	"./Active (2).svg": "4e63",
	"./ActiveroundTickPlus_1.svg": "394e",
	"./Ai.svg": "f9f9",
	"./All-projects-icons/assess.svg": "87ff",
	"./All-projects-icons/cand.svg": "11dc",
	"./All-projects-icons/rec.svg": "ecdf",
	"./All-projects-icons/training.svg": "3f74",
	"./Close.svg": "61da",
	"./CloseImg.svg": "d77a",
	"./Download.svg": "7f35",
	"./Evaluate Tests gry (1).svg": "b783",
	"./Group 2146roundClose.svg": "eb4b",
	"./Group 56578backArrow.svg": "43ab",
	"./Imagecancleicon.svg": "2936",
	"./ImgCancle.svg": "851c",
	"./ImgCloseIcon.svg": "0201",
	"./NocodingQuestion.svg": "7fc3",
	"./Section.png": "f792",
	"./SimplifyLogo.png": "bbc9",
	"./SimplifyMyCareerLogo.jpg": "ba1d",
	"./TestPic.png": "e51a",
	"./Testlockred.svg": "3b31",
	"./Testunlockgreen.svg": "c869",
	"./TopicPic.png": "7675",
	"./Vector.svg": "c64c",
	"./VectorremovePerson.svg": "7f29",
	"./VectorshareLink.svg": "3fa9",
	"./access-pen.svg": "4cb9",
	"./activate.svg": "28b4",
	"./active.svg": "453c",
	"./activitydetail.svg": "ca0b",
	"./addConfidTooltip.svg": "c3dc",
	"./addTestCase.svg": "4f7a",
	"./addblock.svg": "c551",
	"./addicongraywhite.svg": "e80a",
	"./addsecicon.svg": "1186",
	"./ascending1.svg": "7a96",
	"./assess-main-downArrow.svg": "a5b7",
	"./assess-main-upArrow.svg": "6915",
	"./attachicon.svg": "7964",
	"./attempted.svg": "9aba",
	"./audio.svg": "4242",
	"./backArrow.svg": "e357",
	"./bckarrow.svg": "6cfc",
	"./blue-xmark.svg": "54c3",
	"./blueCodeSnip.svg": "a7e2",
	"./blueGroup.svg": "bf7f",
	"./blueQues.svg": "0d95",
	"./blueTestCase.svg": "52e2",
	"./bluesparkle.svg": "b5db5",
	"./calendar.svg": "1a34",
	"./cardviewicon.svg": "5985",
	"./carrotdown.svg": "133c",
	"./caution.svg": "4ca7",
	"./clonetest.svg": "fe40",
	"./closeBtn.svg": "ad8c",
	"./closeicon.svg": "5cac",
	"./codeSnippetinvalid.svg": "613e",
	"./codesnippetinvalidfill.svg": "8152",
	"./codetest_add.svg": "1dec",
	"./codetest_nodata.svg": "c7bb",
	"./codingTest.svg": "9066",
	"./codingicon.svg": "867b",
	"./codingiconred.svg": "ae27",
	"./coming.jpg": "07d1",
	"./common-icons/BackArrow.svg": "2060",
	"./common-icons/addDosnDont.svg": "9fdc",
	"./common-icons/arrow.svg": "1425",
	"./common-icons/ascending.svg": "4556",
	"./common-icons/blue-cross.svg": "6abb",
	"./common-icons/blueRightArrow.svg": "4b92",
	"./common-icons/bluedownarrow.svg": "9b34",
	"./common-icons/calender.svg": "2b77",
	"./common-icons/changeconfig.svg": "9c2e",
	"./common-icons/descending.svg": "5af2",
	"./common-icons/downsort.svg": "dd23",
	"./common-icons/dragIndicator.svg": "c94c",
	"./common-icons/edit.svg": "798f",
	"./common-icons/empty-projects.svg": "6e4c",
	"./common-icons/fil_selected.svg": "de53",
	"./common-icons/filter.svg": "4138",
	"./common-icons/greyEdit.svg": "7739",
	"./common-icons/greyLine.svg": "c8be",
	"./common-icons/magni.svg": "4ca7c",
	"./common-icons/modal-back-arrow.svg": "ce09",
	"./common-icons/nosort.svg": "8515",
	"./common-icons/page-arrow.svg": "6fce",
	"./common-icons/pageCountArrow.svg": "b640c",
	"./common-icons/pageLeft.svg": "6e75",
	"./common-icons/pageRight.svg": "f558",
	"./common-icons/preview-links.svg": "4e71",
	"./common-icons/saveIcon.svg": "ccc0",
	"./common-icons/upsort.svg": "a525",
	"./common-icons/view.svg": "8f04",
	"./common-icons/warn-modal.svg": "bbe0",
	"./common-icons/warning-icon.svg": "d233b",
	"./common-icons/white-cross.svg": "c113",
	"./common-icons/whiteAdd.svg": "bf75",
	"./common-icons/whitePlus.svg": "7ad7",
	"./common-icons/whitefilter.svg": "f713",
	"./config-icons/add-dos-donts.svg": "c203",
	"./cross-round.svg": "fb01",
	"./css/globalStyle.css": "e434",
	"./css/style.css": "6672",
	"./css/typography.css": "fbbc",
	"./dashedLine.svg": "52ec",
	"./defaultdp.svg": "530d",
	"./deletegreyBin.svg": "ca75",
	"./deleteicon.svg": "0d76",
	"./deletepopupicon.svg": "9ea8",
	"./demoImage.svg": "eac6",
	"./disabled-edit.svg": "76ee",
	"./disablesixdots.svg": "f0aa",
	"./dots (1).svg": "0144",
	"./double arrow.svg": "7e7b",
	"./downarrow.svg": "4995",
	"./downloadTestCase.svg": "895a",
	"./drafticon.svg": "d04a",
	"./edit.svg": "6582",
	"./editSectionName.svg": "e6a6",
	"./edit_Pencil.svg": "009f",
	"./editdisabled-new.svg": "078e",
	"./editdisabled.svg": "8488",
	"./editicon.svg": "5068",
	"./ellipseicon.svg": "713e",
	"./evalViewCandidateIllustration.svg": "65f5",
	"./evaluated.svg": "64a9",
	"./eyeicon.svg": "c6cb",
	"./file.svg": "46c7",
	"./fileediticon.svg": "9dea",
	"./fileicon.svg": "0feb",
	"./fileupload.svg": "05dd",
	"./fillcaution.svg": "bcfa",
	"./filtericon.svg": "f0da",
	"./filtersorticon.svg": "248a",
	"./fullscreen.svg": "8625",
	"./generate link icon.svg": "51fa",
	"./go-pri.svg": "570d",
	"./graycancel.svg": "fee4",
	"./graydelete.svg": "18ef",
	"./greenEvaluator.svg": "456f",
	"./greenTick.svg": "2c30",
	"./greenTickBack.svg": "a21b",
	"./greyAdd.svg": "1722",
	"./greyBin (1).svg": "fa7a",
	"./greyCodeSnip.svg": "099b",
	"./greyCross-1.svg": "073e",
	"./greyCross.svg": "1e2f",
	"./greyDownArrow.svg": "dd50",
	"./greyQues.svg": "ec7f",
	"./greyTestCase.svg": "e7c4",
	"./greyTick.svg": "bfd0",
	"./greydot.svg": "8abf",
	"./gridicon.svg": "f633",
	"./gridviewicon.svg": "054f",
	"./headphone.svg": "4945",
	"./hoverZoomimg.svg": "8b31",
	"./icons/Archivetest/archiveicon.svg": "77c4",
	"./icons/Archivetest/archivetagtest.svg": "4cc5",
	"./icons/Archivetest/closexmark.svg": "9bbd",
	"./icons/Archivetest/delete.svg": "af61",
	"./icons/Archivetest/edit.svg": "f143",
	"./icons/Archivetest/emptytest.svg": "4594",
	"./icons/Archivetest/greencheck.svg": "a75d",
	"./icons/Archivetest/greenlock.svg": "c911",
	"./icons/Archivetest/greycheck.svg": "7876",
	"./icons/Archivetest/greyplus.svg": "fe34",
	"./icons/Archivetest/notview.svg": "a10b",
	"./icons/Archivetest/redlock.svg": "29e5",
	"./icons/Archivetest/rightarrow.svg": "23f2",
	"./icons/Archivetest/tickmark.svg": "b889",
	"./icons/Archivetest/vieweye.svg": "b6d5",
	"./icons/Archivetest/yellowcaution.svg": "9992",
	"./icons/Hire3XLogo.svg": "67cd",
	"./icons/Qpbuilder/audioGradient.svg": "2585",
	"./icons/Qpbuilder/audioMic.svg": "a94c",
	"./icons/Qpbuilder/checkboxtick.svg": "539c",
	"./icons/Qpbuilder/cpasmnticon.svg": "1988",
	"./icons/Qpbuilder/cross.svg": "8939",
	"./icons/Qpbuilder/delete-fail.svg": "9054",
	"./icons/Qpbuilder/delete.svg": "90cd",
	"./icons/Qpbuilder/disableplusicon.svg": "ab43a",
	"./icons/Qpbuilder/edit.svg": "a3ad",
	"./icons/Qpbuilder/imagecheck.jpg": "e601",
	"./icons/Qpbuilder/imageclose.svg": "a841",
	"./icons/Qpbuilder/imageclose2.svg": "94d8",
	"./icons/Qpbuilder/imagecloseicon.svg": "9abd",
	"./icons/Qpbuilder/imagepreview.svg": "a002",
	"./icons/Qpbuilder/mcqoptiondelete.svg": "7b83",
	"./icons/Qpbuilder/minimizeleft.svg": "7c36",
	"./icons/Qpbuilder/minimizeright.svg": "e2e0",
	"./icons/Qpbuilder/mtficon.svg": "2d4f",
	"./icons/Qpbuilder/nocodequestions.svg": "83d5",
	"./icons/Qpbuilder/optionimage.svg": "9f84",
	"./icons/Qpbuilder/qbdelete.svg": "1eadd",
	"./icons/Qpbuilder/qbfilter.svg": "6100",
	"./icons/Qpbuilder/sixdots.svg": "349c",
	"./icons/Qpbuilder/testpreview.svg": "2d22",
	"./icons/Qpbuilder/uploadicon.svg": "669b",
	"./icons/Qpbuilder/viewresult.svg": "5449",
	"./icons/Qpbuilder/warning.svg": "24e6",
	"./icons/Reports/addIndividual.svg": "3607",
	"./icons/Reports/addgroup.svg": "39a3",
	"./icons/Reports/bckarrow.svg": "601b",
	"./icons/Reports/cautionwhite.svg": "39ae",
	"./icons/Reports/deleteicon.svg": "7464",
	"./icons/Reports/disableconfig.svg": "883b",
	"./icons/Reports/disablesend.svg": "6ac4",
	"./icons/Reports/disableshared.svg": "b69e",
	"./icons/Reports/disableshareicon.svg": "e8b6",
	"./icons/Reports/disabletaken.svg": "0776",
	"./icons/Reports/disableupdate.svg": "4ffb",
	"./icons/Reports/enableconfigicon.svg": "a8d1",
	"./icons/Reports/enableshareicon.svg": "7b64",
	"./icons/Reports/enableupdate.svg": "15ff",
	"./icons/Reports/evaluator.svg": "5b66",
	"./icons/Reports/grouppeople.svg": "eada",
	"./icons/Reports/nogroupdata.svg": "09c5",
	"./icons/Reports/notConfigured.svg": "6823",
	"./icons/Reports/notshared.svg": "b9d0",
	"./icons/Reports/removeEmail.svg": "1fa7",
	"./icons/Reports/report1.svg": "6aba",
	"./icons/Reports/sharedgreenicon.svg": "7b93",
	"./icons/Reports/singlepep.svg": "5c79",
	"./icons/Reports/takenicon.svg": "49a3",
	"./icons/Reports/tp-blue-cir.svg": "805b",
	"./icons/Reports/tp-green-cir.svg": "75f0",
	"./icons/Reports/tp-yellow-cir.svg": "a4b0",
	"./icons/Reports/whitedelete.svg": "802c",
	"./icons/Reports/whitefilter.svg": "1464",
	"./icons/Reports/wrongmark.svg": "ff52",
	"./icons/access-delete.svg": "7f71",
	"./icons/access-drop-down.svg": "0b75",
	"./icons/access-pen.svg": "2b79",
	"./icons/accesscontrol/close (4).svg": "f85e",
	"./icons/accesscontrol/closecard.svg": "6769",
	"./icons/accesscontrol/editdisableicon.svg": "47a3",
	"./icons/accesscontrol/emptyprivilage.svg": "ebdb",
	"./icons/accesscontrol/evaldone.svg": "3864",
	"./icons/accesscontrol/evalpend.svg": "db21",
	"./icons/accesscontrol/green.svg": "d453",
	"./icons/accesscontrol/inputsearch copy.svg": "61d4",
	"./icons/accesscontrol/inputsearch.svg": "cbe5",
	"./icons/accesscontrol/yellow.svg": "d7bd",
	"./icons/close-icon.svg": "3e79",
	"./icons/config.svg": "0d82",
	"./icons/configillustration.svg": "798d",
	"./icons/content1Linux.svg": "03b4",
	"./icons/content2Linux.svg": "fad2",
	"./icons/dash.svg": "bfba",
	"./icons/expandactive.svg": "c3c0",
	"./icons/expandnonactive.svg": "1586",
	"./icons/h3xlogo.svg": "ebd7",
	"./icons/header/defaultprofilepic.svg": "9822",
	"./icons/header/downarrow.svg": "550c",
	"./icons/header/logout.svg": "ac96",
	"./icons/header/switchapparrow.svg": "a87c",
	"./icons/header/uparrow.svg": "e41d",
	"./icons/inputsearch.svg": "ed87",
	"./icons/not.svg": "3fbe",
	"./icons/proctoring/Email.svg": "a0ab",
	"./icons/proctoring/audio.svg": "be33",
	"./icons/proctoring/autouparrow.svg": "59e5",
	"./icons/proctoring/bluedelicon.svg": "9614",
	"./icons/proctoring/bluedownarrow.svg": "3d44",
	"./icons/proctoring/coding-test-In-active-tab.svg": "29b2",
	"./icons/proctoring/coding-test-active-tab.svg": "77b7",
	"./icons/proctoring/completed.svg": "7727",
	"./icons/proctoring/cpasmnticon.svg": "5fec",
	"./icons/proctoring/downarrow.svg": "bf42",
	"./icons/proctoring/dp.png": "4c34",
	"./icons/proctoring/emptytext.svg": "7848",
	"./icons/proctoring/evalblue.svg": "db219",
	"./icons/proctoring/evaldone.svg": "85f8",
	"./icons/proctoring/evalgreen.svg": "a0d5",
	"./icons/proctoring/evalred.svg": "6bb3",
	"./icons/proctoring/evaluatedone.svg": "e04b",
	"./icons/proctoring/evaluatorblue.svg": "0373",
	"./icons/proctoring/evaluatorred.svg": "1839",
	"./icons/proctoring/evalyellow.svg": "1130",
	"./icons/proctoring/eye.svg": "d595",
	"./icons/proctoring/eyeimage.svg": "673c",
	"./icons/proctoring/gotoreport.svg": "a18e",
	"./icons/proctoring/inactive-codingtest.svg": "d4f4d",
	"./icons/proctoring/infoicon.svg": "24fb",
	"./icons/proctoring/location.svg": "8b63",
	"./icons/proctoring/log.svg": "5e4b",
	"./icons/proctoring/noCommunicationTest.svg": "b3fe",
	"./icons/proctoring/noFeedback.svg": "8f19",
	"./icons/proctoring/noGroup.svg": "cf4f",
	"./icons/proctoring/noID.svg": "85b7",
	"./icons/proctoring/noImage.svg": "4145",
	"./icons/proctoring/noIndividual.svg": "5036",
	"./icons/proctoring/noTypingTest.svg": "cb79",
	"./icons/proctoring/noVideo.svg": "4c72",
	"./icons/proctoring/noproctorgroups.svg": "9379",
	"./icons/proctoring/notests.svg": "e0cb",
	"./icons/proctoring/ongoing.svg": "1068",
	"./icons/proctoring/overallSummary.svg": "14f6",
	"./icons/proctoring/pause.svg": "2b2e",
	"./icons/proctoring/play.svg": "3078",
	"./icons/proctoring/priorityicon.svg": "48f6",
	"./icons/proctoring/proctoring-testcase-infoIcon.svg": "334a",
	"./icons/proctoring/protoring-codeTest-rightArrow.svg": "c484",
	"./icons/proctoring/result.svg": "e21f",
	"./icons/proctoring/rightarrow.svg": "23bb",
	"./icons/proctoring/rightemptyimage.svg": "70d7",
	"./icons/proctoring/righttext.svg": "0dbe",
	"./icons/proctoring/sampleimg.png": "48ee",
	"./icons/proctoring/searchicon.svg": "1865",
	"./icons/proctoring/sections-active-tab.svg": "a856",
	"./icons/proctoring/sections-inactive-tab.svg": "ceb5",
	"./icons/proctoring/tv.svg": "63d7",
	"./icons/proctoring/uparrow.svg": "f6a3",
	"./icons/proctoring/viewresult.svg": "1139",
	"./icons/proctoring/whitedownarrow.svg": "18f1",
	"./icons/proctoring/whiteplus.svg": "be06",
	"./icons/proctoring/yetToStart.svg": "0788",
	"./icons/repnxtno.svg": "b940",
	"./icons/share/ascending.svg": "feaf",
	"./icons/share/copyDisabled.svg": "5dce",
	"./icons/share/descending.svg": "51aa",
	"./icons/share/nogroup.svg": "3e44",
	"./icons/share/nogroupimg.svg": "3310",
	"./icons/share/nosort.svg": "7b32",
	"./icons/share/recruitmentGroup.svg": "0be4",
	"./icons/sidenav/Accesscontrolgray.svg": "2bae",
	"./icons/sidenav/Accesscontrolred.svg": "e81e",
	"./icons/sidenav/Acevaluator.svg": "d80f",
	"./icons/sidenav/Autogenerationtestgray.svg": "23cf",
	"./icons/sidenav/Autogenerationtestred.svg": "4577",
	"./icons/sidenav/Evaluate Tests gry.svg": "34f3",
	"./icons/sidenav/Evaluate Tests red.svg": "bc7e",
	"./icons/sidenav/Groupgray.svg": "2f97",
	"./icons/sidenav/Groupred.svg": "b758",
	"./icons/sidenav/Homegray.svg": "e9fd",
	"./icons/sidenav/Homered.svg": "3b9b",
	"./icons/sidenav/Inaceval.svg": "a3a5",
	"./icons/sidenav/InactiveProgress.svg": "d3d8",
	"./icons/sidenav/Menu icon.svg": "2d9f",
	"./icons/sidenav/MenuActive.svg": "e136",
	"./icons/sidenav/MenuClose.svg": "4fd5",
	"./icons/sidenav/MenuIcon.svg": "cc0a",
	"./icons/sidenav/Proctoringgray.svg": "f682",
	"./icons/sidenav/Proctoringred.svg": "b668",
	"./icons/sidenav/Reportgray.svg": "f0b4",
	"./icons/sidenav/Reportred.svg": "3852",
	"./icons/sidenav/Reports-Assessment.svg": "82b9",
	"./icons/sidenav/Reports-Assessmentgry.svg": "3cb6",
	"./icons/sidenav/Vector.svg": "e6c3",
	"./icons/sidenav/activeProgress.svg": "640d",
	"./icons/sidenav/arrow down.svg": "c279",
	"./icons/sidenav/questionbankgray.svg": "7934",
	"./icons/sidenav/questionbankred.svg": "6607",
	"./icons/sidenav/red-downarrow.svg": "98b1",
	"./icons/sidenav/red-uparrow.svg": "ae97",
	"./icons/sidenav/side-downarrow.svg": "79fa",
	"./icons/sidenav/side-uparrow.svg": "3c91",
	"./icons/sidenav/transaction-active..svg": "cadc",
	"./icons/sidenav/transaction-inactive.svg": "821f",
	"./icons/successfullyshared.svg": "9ac2",
	"./icons/successrocket.svg": "c57e",
	"./icons/test.svg": "4498",
	"./icons/testconfig/Config-icon-testPage.svg": "9a8c",
	"./icons/testconfig/bg.png": "e769",
	"./icons/testconfig/eye-iconPreviewTest-testPage.svg": "9f7b",
	"./icons/testconfig/frosty.svg": "abb6",
	"./icons/testconfig/leftArrow.svg": "7bd2",
	"./icons/testconfig/noGroups.svg": "c453",
	"./icons/testconfig/nodata.svg": "1ab8",
	"./icons/testconfig/noindividual.svg": "04d0",
	"./icons/testconfig/notestconfig.svg": "c377",
	"./icons/testconfig/testconfig.svg": "e4a2",
	"./icons/testconfig/testconfigIllustration.svg": "4707",
	"./icons/testconfig/testpreviewIllustration.svg": "7700",
	"./icons/testconfigicon.svg": "b640",
	"./icons/testpreviewillustration.svg": "af96",
	"./icons/unsuccessfullshare.svg": "b14c2",
	"./icons/unsuccessrocket.svg": "0252",
	"./icons/uparrow.svg": "9447",
	"./icons/uploadexcel/closeicon.svg": "48b6",
	"./icons/uploadexcel/downarrow.svg": "5b97",
	"./icons/uploadexcel/downloadicon.svg": "8650",
	"./icons/uploadexcel/inputsearch.svg": "d954",
	"./icons/uploadexcel/singlecross.svg": "42e4",
	"./icons/uploadexcel/swpfilter.svg": "626d",
	"./icons/uploadexcel/uploadicon.svg": "484d",
	"./icons/whiteuparrow.svg": "18bc",
	"./image-capture.svg": "af9f",
	"./image.svg": "19e7",
	"./inactive.svg": "2684",
	"./info.svg": "07e6",
	"./infoicon.svg": "cdf5",
	"./inputsearch.svg": "e283",
	"./interchange.svg": "2293",
	"./kcbackbutton.svg": "4e3e",
	"./keycloakbg.png": "2cc9",
	"./leftarrow.svg": "7d01",
	"./leftright.svg": "be2b",
	"./leftvector.svg": "7a72",
	"./lock (1) 1redLock_1 (1).svg": "e96e",
	"./lock (1) 1redLock_1.svg": "7896",
	"./lock (1).svg": "9b52",
	"./lock grn.svg": "449d",
	"./lockicoinactive.svg": "f04e",
	"./lockicon.svg": "4a3d",
	"./lockiconactive.svg": "08f0",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./magnify.png": "0e39",
	"./magnifying.jpg": "3d5e",
	"./mainProfile/down_arrow.svg": "6d9d",
	"./mainProfile/google_chrome.svg": "2613",
	"./mainProfile/profAsses.svg": "df58",
	"./mainProfile/profCand.svg": "8755",
	"./mainProfile/profRec.svg": "82ed",
	"./mainProfile/profTran.svg": "ff0e",
	"./mainProfile/up_arrow.svg": "f378",
	"./maindashboard/calenders.svg": "87c1",
	"./maindashboard/linkedin.svg": "3a8d",
	"./maindashboard/mlogo.svg": "5e06",
	"./maindashboard/naukri.svg": "f578",
	"./maindashboard/search-bar-icon.svg": "edef",
	"./maindashboard/searchblockbtn.svg": "90d2",
	"./maindashboard/sharebutton.svg": "61e7",
	"./maindashboard/shine.svg": "ac97",
	"./matchoption.svg": "8ced",
	"./mobileScreen-alertIcon.svg": "8363",
	"./newimgs/activecodingtest.svg": "edc7",
	"./newimgs/activecommu.svg": "1d7d",
	"./newimgs/activesection.svg": "712d",
	"./newimgs/address.svg": "d01b",
	"./newimgs/amazing-meter.svg": "f620",
	"./newimgs/answerline.svg": "6b58",
	"./newimgs/backarrowgrey.svg": "c4f7",
	"./newimgs/blueimage.png": "f2d0",
	"./newimgs/blueinfo.svg": "cf99",
	"./newimgs/candanswericon.svg": "767c",
	"./newimgs/chevoron.svg": "85fd",
	"./newimgs/circulararw.svg": "09e6",
	"./newimgs/codesandbox.svg": "8fe7",
	"./newimgs/device.svg": "6faf",
	"./newimgs/doubledash.svg": "84b2",
	"./newimgs/dummypng.png": "2b21",
	"./newimgs/emptycamfeed.svg": "2261",
	"./newimgs/emptycapture.svg": "3437",
	"./newimgs/emptyfdbck.svg": "f5f7",
	"./newimgs/emptytypingtest.svg": "58e0",
	"./newimgs/facecam.png": "5699",
	"./newimgs/faceempty.svg": "41fb",
	"./newimgs/fair-meter.svg": "d084",
	"./newimgs/good-meter.svg": "ee40",
	"./newimgs/greenarw.svg": "1ead",
	"./newimgs/greenstars.svg": "f6fe",
	"./newimgs/greentick.svg": "85f0",
	"./newimgs/greychevoron.svg": "f2e8",
	"./newimgs/greycross.svg": "78fd",
	"./newimgs/greytick.svg": "5262",
	"./newimgs/hearanswer.svg": "0bcb",
	"./newimgs/hire3xai.svg": "698c",
	"./newimgs/inactivecodingtest.svg": "5a63",
	"./newimgs/inactivecommu.svg": "7e24",
	"./newimgs/inactivesection.svg": "5ba7",
	"./newimgs/infoicon.svg": "225d",
	"./newimgs/instancetime.svg": "4240",
	"./newimgs/leaderboard.svg": "e86d",
	"./newimgs/location.svg": "c364",
	"./newimgs/lock.svg": "2c0f",
	"./newimgs/no-activity.svg": "7e48",
	"./newimgs/no-communication.svg": "84e9",
	"./newimgs/nocommutest.svg": "23d8",
	"./newimgs/nothear.svg": "99d6",
	"./newimgs/notviewicon.svg": "add3",
	"./newimgs/okay-meter.svg": "fa22",
	"./newimgs/pauseicon.svg": "72ce",
	"./newimgs/playbtn.svg": "bede",
	"./newimgs/playerpause.svg": "e0ab",
	"./newimgs/playerplay.png": "5e3a",
	"./newimgs/red-cross.svg": "b06c",
	"./newimgs/redcross.svg": "bff9",
	"./newimgs/replay.svg": "8882",
	"./newimgs/sandboxcross.svg": "222b",
	"./newimgs/sandboxtick.svg": "2faf",
	"./newimgs/sixdots.svg": "f26c",
	"./newimgs/twogirls.png": "2a25",
	"./newimgs/viewmarks.svg": "2de6",
	"./newimgs/x-close.svg": "8880",
	"./no-sand.svg": "9318",
	"./no-view.svg": "81cc",
	"./noEdit.svg": "515e",
	"./noGroupDataReport.svg": "d109",
	"./noQuesTag.svg": "dec7",
	"./noQuestions.svg": "07f3",
	"./noTagQues.svg": "1034",
	"./noTest.svg": "7924",
	"./nocandidate.svg": "5a21",
	"./nocodequestions.svg": "6717",
	"./nodata.svg": "17ac",
	"./nodataicon.svg": "9aea",
	"./nogroupdata.svg": "5eff",
	"./nogrp_1a.svg": "8847",
	"./non-Attempted.svg": "77c3",
	"./non-evaluated.svg": "e162",
	"./nonView.svg": "14c4",
	"./nosearchdataCT.svg": "0e2f",
	"./noteicon.svg": "b4f3",
	"./notopicdata.svg": "f086",
	"./notview.svg": "59d6",
	"./notviewicon.svg": "d137",
	"./notviewiconn.svg": "8471",
	"./notviewiconproctor.svg": "5e84",
	"./notviewicons.svg": "9585",
	"./orangeProfile.svg": "681d",
	"./overiew-report-ill.svg": "bce0",
	"./pass.svg": "b353",
	"./path-forward.svg": "d1bb",
	"./pause-icon.svg": "d8c5",
	"./pencilicon.svg": "0d05",
	"./plusicon.svg": "6f35",
	"./preview eye (2).svg": "168c",
	"./preview eye.svg": "29a6",
	"./pricing.svg": "9361",
	"./procnodata.svg": "8960",
	"./profile.svg": "b855",
	"./projects-icons/Line.svg": "2c42",
	"./projects-icons/activateWarn.svg": "6b11",
	"./projects-icons/attempt-warning.svg": "e24f",
	"./projects-icons/big-warning-red.svg": "ef75",
	"./projects-icons/calendar-new.svg": "e3bd",
	"./projects-icons/clone-icon.svg": "0a65",
	"./projects-icons/clone-inactive.svg": "ea54",
	"./projects-icons/code-icon.svg": "5f3e",
	"./projects-icons/config-icon.svg": "b2c8",
	"./projects-icons/delete-icon.svg": "845f",
	"./projects-icons/deleteProject.svg": "4c26",
	"./projects-icons/disabled-eye-icon.svg": "62d2",
	"./projects-icons/disabled-load-icon.svg": "807d",
	"./projects-icons/disabled-restrict-icon.svg": "a523",
	"./projects-icons/down-arrow.svg": "6158",
	"./projects-icons/downarrow.svg": "9f85",
	"./projects-icons/edit-icon.svg": "6f84",
	"./projects-icons/empty-admin-console.svg": "0247",
	"./projects-icons/empty-list-projects.svg": "6d6d",
	"./projects-icons/empty-right-projects.svg": "796e",
	"./projects-icons/evaluate-screen/cancel.svg": "d89b",
	"./projects-icons/evaluate-screen/false.svg": "ea2e",
	"./projects-icons/evaluate-screen/givemarks-sb.svg": "4db5",
	"./projects-icons/evaluate-screen/submit.svg": "fd5d",
	"./projects-icons/evaluate-screen/true.svg": "aba2",
	"./projects-icons/evaluate-screen/view-arrow.svg": "4e320",
	"./projects-icons/evaluate-screen/view-sb.svg": "38f2",
	"./projects-icons/group-rec.svg": "55a6",
	"./projects-icons/group.svg": "1deb",
	"./projects-icons/individual.svg": "3c7c",
	"./projects-icons/inform-icon.svg": "4e32",
	"./projects-icons/lock-icon.svg": "67f5",
	"./projects-icons/lockProject.svg": "e55f",
	"./projects-icons/makePrivate.svg": "a7ee",
	"./projects-icons/makePublic.svg": "b48e",
	"./projects-icons/modal-backarrow.svg": "e2d0",
	"./projects-icons/no-search-projects.svg": "d3fc",
	"./projects-icons/popup-icon-blue.svg": "a200",
	"./projects-icons/public-icon.svg": "777d",
	"./projects-icons/purple-bin.svg": "188b",
	"./projects-icons/radio-btn.svg": "5a4b",
	"./projects-icons/reload-icon.svg": "9098",
	"./projects-icons/restrict-icon.svg": "be65",
	"./projects-icons/right-arr.svg": "3c24",
	"./projects-icons/right-tick.svg": "0c1c",
	"./projects-icons/saveMarks.svg": "6af4",
	"./projects-icons/share-icon.svg": "6569",
	"./projects-icons/undoMarks.svg": "37e4",
	"./projects-icons/unlockProject.svg": "770b",
	"./projects-icons/uparrow.svg": "390b",
	"./projects-icons/view-icon.svg": "3038",
	"./projects-icons/view-open.svg": "b4b8",
	"./projects-icons/white-activate.svg": "3239",
	"./projects-icons/wrong-tick.svg": "382c",
	"./projects-icons/x-close.svg": "9d1c",
	"./questioninvalid.svg": "f69d4",
	"./realMagnify.png": "b876",
	"./redCross.svg": "b621",
	"./redCrossBack.svg": "f34b",
	"./redEdit.svg": "5698",
	"./redFile.svg": "f556",
	"./report_candidate.svg": "02d9",
	"./rightarrow.svg": "96a0",
	"./rightfilterwhite.svg": "71bf",
	"./rightmark.svg": "1078",
	"./rightnxt.svg": "fb40",
	"./roundClose.svg": "e311",
	"./sandbox-evaluation-pending.svg": "613f",
	"./scatterimg.svg": "3ab0",
	"./schedule_send_black_24dp 1greenShareArrow.svg": "9ce8",
	"./search-bar-icon.svg": "b95e",
	"./searchicon.svg": "e3da",
	"./searchnotfound.svg": "d7f2",
	"./searchusericon.svg": "67f8",
	"./secediticon.svg": "de09",
	"./secplusicon.svg": "6f9c",
	"./section-validation.svg": "28e3",
	"./sectionDelete.svg": "7a9e",
	"./sectiondownarrow.svg": "a9fd",
	"./sectionuparrow.svg": "3d72",
	"./sent.mp4": "218d",
	"./share.png": "75e1",
	"./sharecopy.svg": "e9df",
	"./sharegroupicon.svg": "82e1",
	"./shareimg.svg": "6d9f",
	"./sharepageimage.svg": "2948",
	"./sharepageimg.svg": "ea00",
	"./shareupdate.svg": "2167",
	"./singleusericon.svg": "f274",
	"./sort - down.svg": "16d1",
	"./sort - up.svg": "1e4f",
	"./sort -none.svg": "8308",
	"./sorticon.svg": "8034",
	"./switchapps/Sappsmain.svg": "bc75",
	"./switchapps/asmnt.svg": "6ce0",
	"./switchapps/assessdis.svg": "3dea",
	"./switchapps/candidate.svg": "4956",
	"./switchapps/candidatedis.svg": "6012",
	"./switchapps/chevron-down.svg": "1ae4",
	"./switchapps/chevron-up.svg": "9dcf",
	"./switchapps/recdis.svg": "ba9c",
	"./switchapps/recruitment.svg": "733f",
	"./switchapps/training.svg": "bb47",
	"./switchapps/trainingdis.svg": "5f3a",
	"./swp-noDATA.svg": "73ef",
	"./testCaseFail.svg": "4ecc",
	"./testCasePass.svg": "6a72",
	"./testcaseinvalid.svg": "ae9c",
	"./testtimewarning.svg": "87c4",
	"./topicProgress.svg": "0d3c",
	"./transaction/earn-back.svg": "6393",
	"./transaction/earning.svg": "e760",
	"./transaction/page-right.svg": "4a5b",
	"./transaction/right-arrow.svg": "f643",
	"./transaction/transaction.svg": "0243",
	"./transaction/withdraw.svg": "6ccb",
	"./unlockcloseicon.svg": "2a30",
	"./uparrow-preview.svg": "bd83",
	"./uparrow.svg": "7a27",
	"./update-arrows-svgrepo-com 1refresh.svg": "3f0a",
	"./updownsort.svg": "9edf",
	"./uploadTestCase.svg": "6d55",
	"./uploadTestModal.svg": "4258",
	"./usericon.svg": "9ad4",
	"./vedio.svg": "362d",
	"./vertical-line.svg": "9cfe",
	"./videocam.svg": "a81e",
	"./videoclose.svg": "dc0c",
	"./viewiconn.svg": "89e6",
	"./visibility_off.svg": "93c2",
	"./visibility_off_black (2).svg": "09a5",
	"./whiteAdd.svg": "e7f7",
	"./whiteAddbtn.svg": "e15a",
	"./whiteDown.png": "0edc",
	"./whiteDown.svg": "0c22",
	"./whitePencil.svg": "ecaf",
	"./whitecarrotdown.svg": "b058",
	"./whitedelete.svg": "d4a5",
	"./whitedownarrow.svg": "a097",
	"./whitefilter.svg": "6b79",
	"./whiterightarrow.svg": "bc6d",
	"./whitetick.svg": "ffe4",
	"./whiteuparrow.svg": "d8a4",
	"./xmark.svg": "9755",
	"./yellowAlert.svg": "911d",
	"./yellowOval.svg": "01a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";